import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import animationStyles from 'components/util/animation/animation.module.scss'
import useDelayedActiveState from 'lib/react/hooks/useDelayedActiveState'
import classNames from 'lib/util/classNames'
import Logo from '../Logo/Logo'
import styles from './Loading.module.scss'

/**
 * The `Loading`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Loading (props) {
  const { className } = props
  const isActive = useDelayedActiveState(true, 0.75, 0)
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        styles.container,
        isActive && animationStyles.fadeUp
      ]),
    [className, isActive]
  )

  return (
    <div className={classNameOutput}>
      <div className={styles.display}>
        <div className={styles.background}>
          <div className={styles.shimmer} />
        </div>
        <Logo.Icon className={styles.logo} />
      </div>
    </div>
  )
}

/** @type {object} */
Loading.propTypes = {
  className: PropTypes.string
}

/** @type {object} */
Loading.defaultProps = {
  className: ''
}

// Memoize
export default memo(Loading)
